import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'error', isVisible, onClose, duration = 5000 }) => {
    useEffect(() => {
        if (isVisible && onClose) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose, duration]);

    if (!isVisible) return null;

    const getToastStyles = () => {
        switch (type) {
            case 'success':
                return 'bg-green-500/90 border-green-500/50 text-white';
            case 'warning':
                return 'bg-yellow-500/90 border-yellow-500/50 text-white';
            case 'error':
            default:
                return 'bg-red-500/90 border-red-500/50 text-white';
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircle className="w-5 h-5" />;
            case 'warning':
            case 'error':
            default:
                return <AlertCircle className="w-5 h-5" />;
        }
    };

    return (
        <div className="fixed top-4 right-4 z-50 animate-slide-in">
            <div className={`
                flex items-center gap-3 p-4 rounded-lg border backdrop-blur-md
                ${getToastStyles()}
                max-w-md shadow-lg
            `}>
                {getIcon()}
                <p className="text-sm font-medium flex-1">{message}</p>
                {onClose && (
                    <button
                        onClick={onClose}
                        aria-label="Dismiss"
                        className="p-1 rounded-full hover:bg-white/10 transition-colors"
                    >
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Toast;